import { createStore, del, get, set, type UseStore } from "idb-keyval";

// idb-keyval's createStore creates one database with one object store.
// Each store MUST use a separate database name — sharing a name causes only
// the first store's object store to be created (onupgradeneeded only fires once).
export const reactQueryIdbStore = createStore("clutch-rq-cache", "store");
export const offlineMutationIdbStore = createStore(
	"clutch-offline-mutations",
	"store",
);
export const persistedDraftIdbStore = createStore(
	"clutch-persisted-drafts",
	"store",
);

export async function readIdbValue<T>(
	key: string,
	store: UseStore,
): Promise<T | null> {
	try {
		const value = await get<T>(key, store);
		return value ?? null;
	} catch {
		return null;
	}
}

export async function writeIdbValue<T>(key: string, value: T, store: UseStore) {
	try {
		await set(key, value, store);
	} catch {
		// IndexedDB may be unavailable (private browsing, quota exceeded).
		// Silently degrade — offline features are best-effort.
	}
}

export async function deleteIdbValue(key: string, store: UseStore) {
	try {
		await del(key, store);
	} catch {
		// Same as writeIdbValue — degrade gracefully.
	}
}
